// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BuildOutlinedSvg from "@fishx/icons-svg/es/asn/BuildOutlined";
import FishxIcon from '../components/FishxIcon';

var BuildOutlined = function BuildOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BuildOutlinedSvg
  }));
};

BuildOutlined.displayName = 'BuildOutlined';
export default React.forwardRef(BuildOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BuildOutlined.js
// module id = 2130
// module chunks = 0